import { createSlice } from "@reduxjs/toolkit";

// Define the initial state using that type
const initialState: IServiceContractState = {
  data: null,
  documents: [],
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  docCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  details: null,
};

export const serviceContractSlice = createSlice({
  name: "serviceContract",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { sourceAction, isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replaceServiceContract: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },
    setServiceContractDocuments: (state, action) => {
      const { data } = action.payload;
      state.documents = data;
      state.docCount = state.documents.length;
    },
    resetServiceContractDocuments: (state) => {
      state.documents = [];
    },
    addServiceContract: (state, action) => {
      const newItem = action.payload.data;
      if (state.data && state.data.length > state.pageSize) {
        state.data.pop();
      }
      state.data = state.data ? [newItem, ...state.data] : [newItem];
      state.totalCount = state.totalCount + 1;
    },
    updateServiceContract: (state, action) => {
      const { localID, data } = action.payload;
      if (localID !== undefined && localID >= 0 && state.data) {
        state.data[localID] = data;
      }
      state.details = data;
    },
    deleteServiceContract: (state, action) => {
      const serviceContractToRemove: IServiceContract = action.payload.data;
      const newServiceContractData =
        state.data &&
        state.data.filter((serviceContract: IServiceContract) => {
          return serviceContract.id !== serviceContractToRemove.id;
        });
      state.data = newServiceContractData;
      state.totalCount = state.totalCount - 1;
    },
    deleteServiceContractDocument: (state, action) => {
      const toRemove: IDocument = action.payload;
      const newData = state.documents.filter((document: IDocument) => {
        return document.documentName !== toRemove.documentName;
      });
      state.documents = newData;
      state.docCount = state.documents.length;
    },
    setServiceContractDetails: (state, action) => {
      state.details = action.payload.data;
    },
  },
});

export const serviceContractActions = serviceContractSlice.actions;

export default serviceContractSlice.reducer;
